import { z } from 'zod';
/**
 * Kategorie akci z letaku (navrh v2). Pevny seznam — kazdy zdroj ma vlastni
 * cleneni a AI zarazuje do tohohle. `hint` rika modelu, co do kategorie patri.
 */
export const OFFER_CATEGORIES = [
    { id: 'ovoce-zelenina', label: 'Ovoce a zelenina', hint: 'ovoce, zelenina, bylinky, ořechy, květiny a sazenice' },
    { id: 'maso-ryby', label: 'Maso a ryby', hint: 'maso, drůbež, ryby, uzeniny, šunka, lahůdky' },
    { id: 'mlecne-vejce', label: 'Mléčné a vejce', hint: 'mléko, sýry, jogurty, tvaroh, máslo, smetana, vejce' },
    { id: 'pecivo', label: 'Pečivo', hint: 'chléb, rohlíky, bagety, koláče a sladké pečivo' },
    { id: 'trvanlive', label: 'Trvanlivé', hint: 'těstoviny, rýže, mouka, cukr, konzervy, oleje, koření, omáčky, cereálie' },
    { id: 'sladke-slane', label: 'Sladké a slané', hint: 'čokolády, sušenky, bonbony, chipsy, křupky, slané pochutiny' },
    { id: 'mrazene', label: 'Mražené', hint: 'zmrzlina, mražená pizza, mražená zelenina a ryby' },
    { id: 'napoje', label: 'Nápoje', hint: 'voda, limonády, džusy, energetické nápoje, káva, čaj' },
    { id: 'alkohol', label: 'Alkohol', hint: 'pivo, víno, lihoviny' },
    { id: 'drogerie', label: 'Drogerie', hint: 'kosmetika, hygiena, zubní pasty, holení, dětské pleny a výživa' },
    { id: 'domacnost', label: 'Domácnost', hint: 'úklid, prací prostředky, toaletní papír, kuchyňské potřeby, bytový textil' },
    { id: 'zvirata', label: 'Zvířata', hint: 'krmivo a potřeby pro psy, kočky a další zvířata' },
    { id: 'naradi-zahrada', label: 'Nářadí a zahrada', hint: 'nářadí, dílna, zahrada, gril, auto a kolo' },
    { id: 'elektronika', label: 'Elektronika', hint: 'spotřebiče, telefony, počítače, baterie, světla' },
    { id: 'obleceni', label: 'Oblečení a obuv', hint: 'oblečení, obuv, sportovní potřeby' },
    { id: 'ostatni', label: 'Ostatní', hint: 'hračky, papírnictví, sezónní zboží a vše, co jinam nepatří' },
];
export const OFFER_CATEGORY_IDS = OFFER_CATEGORIES.map((c) => c.id);
export const OfferCategorySchema = z.enum(OFFER_CATEGORY_IDS);
export function offerCategoryLabel(id) {
    return OFFER_CATEGORIES.find((c) => c.id === id)?.label ?? id;
}
/** Pocet akci v kategorii pro aktualni filtry (bez akci bez kategorie — ty jsou v „Ostatní"). */
export const OfferCategoryCountSchema = z.object({
    id: OfferCategorySchema,
    count: z.number().int().nonnegative(),
});
//# sourceMappingURL=categories.js.map